import { apiClient } from './client';

/**
 * Get all orders (Admin/Teacher, tenant-scoped), one page at a time.
 * @param {{ page?, limit? (max 100), status? (uppercase OrderStatus), search?, sortBy?
 *   ('createdAt'|'amount'|'status'|'customer'), sortOrder?, courseIds? (comma-separated) }} params
 * @returns {{ data: Array, meta: { page, limit, total, totalPages, hasNext, hasPrev } }}
 */
export async function getAllOrders(params = {}) {
  const { data } = await apiClient.get('/payments/admin/orders', { params });
  return data;
}

/**
 * Every order matching `params`, fetched page by page (100 per request). For the CSV export,
 * which has to cover the whole filtered set rather than the page on screen.
 * @param {object} params  same filters as getAllOrders (page/limit are managed here)
 * @param {{ maxPages?: number }} options
 */
export async function getEveryOrder(params = {}, { maxPages = 50 } = {}) {
  const orders = [];
  for (let page = 1; page <= maxPages; page += 1) {
    const res = await getAllOrders({ ...params, page, limit: 100 });
    orders.push(...(res?.data || []));
    if (page >= (res?.meta?.totalPages || 1)) break;
  }
  return orders;
}

/**
 * Get payment statistics (Admin/Teacher) over every order in scope, not one page of them.
 * @param {{ courseIds? (comma-separated; tenant scope always applies) }} params
 * @returns {{ totalOrders, completedOrders, revenue, averageOrderValue, uniqueBuyers,
 *   statusBreakdown: Array<{ status, count }>,
 *   topCourses: Array<{ courseId, title, revenue, orders }>, recentOrders: Array }}
 */
export async function getPaymentStats(params = {}) {
  const { data } = await apiClient.get('/payments/admin/stats', { params });
  return data;
}
